import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8db7be8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "marquee-container" }
const _hoisted_2 = { style: {"width":"40px","background-color":"white","position":"absolute","z-index":"2","border-bottom-left-radius":"26px","border-top-left-radius":"26px"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "card-header"
}
const _hoisted_5 = { class: "card-header-content" }
const _hoisted_6 = {
  key: 1,
  class: "card-header"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header-content-gray" }, /*#__PURE__*/_toDisplayString(0), -1))
const _hoisted_8 = {
  key: 0,
  class: "card-content"
}
const _hoisted_9 = {
  key: 2,
  class: "timeCounter"
}
const _hoisted_10 = { class: "static-number" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = {
  key: 2,
  class: "card-footer"
}
const _hoisted_13 = {
  key: 3,
  class: "card-footer"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }

import {onBeforeUnmount, onMounted, ref} from 'vue'
import {ElMessage} from 'element-plus'
import {getListData} from "@/service/main/system";
import {yesterday} from "@/utils/date-format";


export default /*#__PURE__*/_defineComponent({
  __name: 'Raffle',
  setup(__props) {

const raffle: any = ref({})
const begin: any = ref(false)
const hasActivity: any = ref(false)
const leaveTime: any = ref('')
const awardAmount: any = ref('')
const animateClass: any = ref('')
const animateClassOpened: any = ref('')
const openSts: any = ref(false)
const disabledSts: any = ref(false)
const recordsData: any = ref([])
const marqueeContent: any = ref()
const duration = ref('20s')
let countdownTimer: ReturnType<typeof setInterval> | null = null
const animationTimers: Array<ReturnType<typeof setTimeout>> = []

const scheduleAnimation = (callback: () => void, delay = 0) => {
  const timer = setTimeout(callback, delay)
  animationTimers.push(timer)
}

const stopTimers = () => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null
  }
  animationTimers.splice(0).forEach((timer) => clearTimeout(timer))
}

// 获取考核获取的抽奖次数记录
const getRecordsData = async (startTime: string, endTime: string) => {
  await getListData('/main/employeePointRecord/getRecordsByDate', {startTime, endTime}).then((item) => {
    recordsData.value = item
    duration.value = recordsData.value.length * 6 +'s';
  })
}

// 获取抽奖数据
const getRaffle = () => {
  hasActivity.value = true
  leaveTime.value = calculateCountdown(raffle.value.startTime, raffle.value.endTime)
  if (countdownTimer) clearInterval(countdownTimer)
  countdownTimer = setInterval(() => {
    leaveTime.value = calculateCountdown(raffle.value.startTime, raffle.value.endTime)
  }, 1000)
}

const calculateCountdown = (startDate: string, endDate: string) => {
  const now = new Date() // 获取当前时间
  const start = new Date(startDate) // 活动开始时间
  const end = new Date(endDate) // 活动结束时间

  if (start <= now && end >= now) {
    begin.value = true
    let difference = start.getTime() - now.getTime() // 计算剩余毫秒数

    // 转换成天数、小时、分钟和秒
    const days = Math.floor(difference / (1000 * 60 * 60 * 24))
    difference -= days * (1000 * 60 * 60 * 24)

    const hours = Math.floor(difference / (1000 * 60 * 60))
    difference -= hours * (1000 * 60 * 60)

    const minutes = Math.floor(difference / (1000 * 60))
    difference -= minutes * (1000 * 60)

    const seconds = Math.floor(difference / 1000)

    return `${days}天 ${hours}小时 ${minutes}分 ${seconds}秒`
  } else {
    begin.value = false
    hasActivity.value = false
  }
}

const open = () => {
  if (!disabledSts.value) {
    if (raffle.value.extractNum == 0) {
      ElMessage({
        message: '抽奖机会已用完',
        type: 'warning'
      })
      return
    }
    disabledSts.value = true
    animateClass.value = ''
    // 使用 setTimeout 确保在下一个渲染周期内添加类
    scheduleAnimation(() => {
      animateClass.value = 'animate__shakeX' // 使用 bounce 动画
    }, 0)

    getListData('/main/raffleManage/getRaffle', {raffleId: raffle.value.id}).then((item) => {
      awardAmount.value = item.amount
      scheduleAnimation(() => {
        animateClass.value = 'animate__fadeOut' // 使用 bounce 动画
      }, 1000)
      scheduleAnimation(() => {
        openSts.value = true
        animateClassOpened.value = 'animate__fadeIn'
      }, 2000)
    })
  }
}

const pageBack = () => {
  initRaffleInfo()
  openSts.value = false
  disabledSts.value = false
  scheduleAnimation(() => {
    animateClass.value = ''
    animateClassOpened.value = ''
  })
}

onMounted(() => {
  initRaffleInfo()
})

onBeforeUnmount(stopTimers)

const initRaffleInfo = async () => {
  await getListData('/main/raffleManage/getActivatedRaffle', {}).then((item) => {
    console.log(item)
    if (item != null) {
      raffle.value = item
      getRaffle()
      getRecordsData(item.rafflePointStartTime, item.rafflePointEndTime)
    } else {
      getRecordsData(yesterday(), yesterday())
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: require('@/assets/images/voice.png'),
            style: {"width":"15px","margin-bottom":"2px"}
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", {
          ref_key: "marqueeContent",
          ref: marqueeContent,
          class: "marquee-content",
          style: _normalizeStyle({'animationDuration': duration.value})
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recordsData.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "marquee-item"
            }, _toDisplayString(item), 1))
          }), 128))
        ], 4)
      ]),
      (hasActivity.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_image, {
              style: {"width":"48px","height":"48px"},
              src: require('@/assets/images/coin.png')
            }, null, 8, ["src"]),
            _createVNode(_component_el_image, {
              src: require('@/assets/images/raffle.png')
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(raffle.value.surplusAmountNum), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_image, {
              style: {"width":"48px","height":"48px"},
              src: require('@/assets/images/grayCoin.png')
            }, null, 8, ["src"]),
            _createVNode(_component_el_image, {
              src: require('@/assets/images/grayRaffle.png')
            }, null, 8, ["src"]),
            _hoisted_7
          ]))
    ]),
    default: _withCtx(() => [
      (!openSts.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (hasActivity.value)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  class: _normalizeClass(['animate__animated', animateClass.value]),
                  src: require('@/assets/images/redPacket.png')
                }, null, 8, ["class", "src"]))
              : (_openBlock(), _createBlock(_component_el_image, {
                  key: 1,
                  src: require('@/assets/images/greyPacket.png')
                }, null, 8, ["src"])),
            (!begin.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(leaveTime.value), 1))
              : _createCommentVNode("", true),
            (begin.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 3,
                  class: _normalizeClass([['animate__animated', animateClass.value], "timeBtn"]),
                  onClick: open
                }, " 拆 ", 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (openSts.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(['card-content opened animate__animated', animateClassOpened.value])
          }, [
            _createElementVNode("div", null, [
              _createTextVNode(" 恭喜您抽中"),
              _createElementVNode("span", _hoisted_10, _toDisplayString(awardAmount.value), 1),
              _createTextVNode("元,"),
              _hoisted_11,
              _createTextVNode("请联系经理领取 ")
            ]),
            _createElementVNode("a", {
              class: "backBtn",
              onClick: _withModifiers(pageBack, ["stop","prevent"])
            }, "返回")
          ], 2))
        : _createCommentVNode("", true),
      (begin.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_el_image, {
              style: {"width":"36px","height":"36px"},
              src: require('@/assets/images/gift.png')
            }, null, 8, ["src"]),
            _createElementVNode("div", null, _toDisplayString('本次活动你拥有' + raffle.value.extractNum + '次抽奖机会，每次抽奖消耗' + raffle.value.consumePoint + '积分'), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (hasActivity.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString('活动尚未开始,活动时间：' + raffle.value.startTime + '~' + raffle.value.endTime), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, "活动已结束"))
          ]))
    ]),
    _: 1
  }))
}
}

})